// REACT, STYLE, STORIES & COMPONENT
import React, { useEffect } from 'react';
import styles from './OverlayModal.module.scss';

// ASSETS
import { Icons } from 'assets/icons';

// 3RD PARTY
import classNames from 'classnames';

// OTHER COMPONENTS
// eslint-disable-next-line import/no-cycle
import { Icon } from 'ui/basic';

// UTILS
import { disableScrollingOnBody, enableScrollingOnBody } from 'utils/scrolling';


// COMPONENT: OverlayModal
const OverlayModal = (props) => {
  // PROPS
  const {
    header,
    children,
    footer,
    hasHighestVisibility = false,
    onClose,
  } = props;

  // SPECIAL HOOKS

  useEffect(() => {
    disableScrollingOnBody();
    return () => {
      enableScrollingOnBody();
    };
  }, []);


  // RENDER: OverlayModal
  return (
    <div className={classNames(
      styles.overlayModal,
      { [styles.hasHighestVisibility]: hasHighestVisibility },
    )}
    >
      <div className={styles.header}>
        <span>{ header }</span>

        { onClose && (
          <div
            role='presentation'
            className={styles.close}
            onClick={onClose}
          >
            <Icon icon={Icons.CloseBig} />
          </div>
        ) }
      </div>

      <div
        id='overlay-modal-scrollable-content'
        className={classNames(styles.scrollableContent, {
          [styles.hasFooter]: Boolean(footer),
        })}
      >
        { children }
      </div>

      { footer && (
        <div className={styles.footer}>
          { footer }
        </div>
      ) }

    </div>
  );
};

export default OverlayModal;
